import React from 'react';

import TabPageComponent from '../custom-post-types/tab-page';

const DEFAULT_TAB = 'siliconix-fairchild-cross-reference';

const LiteraturePageComponent = ({ tabPages, productsGroupedByCategories, location }) => {
  return (
    <div className="container mt-5 pb-5">
      <div className="row">
        <div className="col">
          <TabPageComponent
            tabPages={tabPages}
            defaultActiveTab={DEFAULT_TAB}
            productsGroupedByCategories={productsGroupedByCategories} // TODO: remove special treatment for the datasheets page/tab
          />
        </div>
      </div>
    </div>
  );
};

export default LiteraturePageComponent;